const CARD_ISSUING_NETWORK_RANGE: Record<string, { startWith: number; endWith: number }[]> = {
    visa: [{ startWith: 400000, endWith: 499999 }],
    mastercard: [
        { startWith: 222100, endWith: 272099 },
        { startWith: 510000, endWith: 559999 }
    ],
    'american-express': [
        { startWith: 340000, endWith: 349999 },
        { startWith: 370000, endWith: 379999 }
    ],
    jcb: [
        { startWith: 308800, endWith: 310299 },
        { startWith: 311200, endWith: 312099 },
        { startWith: 315800, endWith: 315999 },
        { startWith: 333700, endWith: 334999 },
        { startWith: 352800, endWith: 358999 }
    ]
}

export const getCardIssuingNetwork = (cardNumber: string): string => {
    const clean = String(cardNumber).replace(/\D/g, '')
    if (clean.length < 6) return ''
    const iin = parseInt(clean.slice(0, 6), 10)
    for (const [network, ranges] of Object.entries(CARD_ISSUING_NETWORK_RANGE)) {
        for (const range of ranges) {
            if (iin >= range.startWith && iin <= range.endWith) return network
        }
    }
    return ''
}

// Quick prefix-based brand detection used for the card-number input badge.
// Returns the short brand code (`VISA` / `MC` / `AMEX`) rather than the full
// issuing-network name so it maps directly to `DynamicCreditCardIcons` keys.
export const detectCardBrand = (cardNumber: string): string => {
    const clean = String(cardNumber).replace(/\D/g, '')
    if (clean.length < 6) return ''
    if (/^4/.test(clean)) return 'VISA'
    if (/^5[1-5]/.test(clean)) return 'MC'
    if (/^3[47]/.test(clean)) return 'AMEX'
    return ''
}

// Normalize a raw card-number input into `"1234 5678 9012 3456"` form:
// strips non-digits, caps at 16 digits, then inserts a space every 4 chars.
// Intended for use inside `onChange` of the card-number field.
export const formatCardNumber = (value: string): string => {
    const digits = String(value).replace(/\D/g, '').slice(0, 16)
    return digits.replace(/(.{4})/g, '$1 ').trim()
}
